import React, {useState} from 'react';
import {staffApi} from '@/lib/staffApi';

export function VariantPricingEditor({service, onSaved}) {
    const [draft,setDraft]=useState(null);
    const [busy,setBusy]=useState(false);
    const [error,setError]=useState('');
    const open=async()=>{
        setBusy(true);setError('');
        try {
            const s=await staffApi.getService(service.id);
            setDraft({price:s.price,minutes:s.duration/60,deposit:s.deposit || 0,depositPayment:s.depositPayment || 'disabled'});
        } catch(e){setError(e.message);}
        finally{setBusy(false);}
    };
    const save=async()=>{
        const price=Number(draft.price), minutes=Number(draft.minutes), deposit=Number(draft.deposit);
        if (draft.price==='' || draft.minutes==='' || draft.deposit==='' || !Number.isFinite(price) || price<0 || !Number.isInteger(minutes) || minutes<1 || !Number.isFinite(deposit) || deposit<0 || (draft.depositPayment==='percentage' && deposit>100) || (draft.depositPayment==='fixed' && deposit>price)) {
            setError('Enter a valid price, whole minutes and a deposit no larger than the price (or 100%).');return;
        }
        setBusy(true);setError('');
        try {
            const result=await staffApi.updateService(service.id,{price,duration:minutes*60,deposit,depositPayment:draft.depositPayment});
            onSaved(result.service);setDraft(null);
        } catch(e){setError(e.message);}
        finally{setBusy(false);}
    };
    const field=(key,label,type='number')=><label className="block text-sm">{label}<input type={type} min="0" step={key==='minutes'?'1':'0.01'} value={draft[key]} onChange={e=>setDraft({...draft,[key]:e.target.value})}/></label>;
    return <div className="space-y-3">
        {!draft ? <button type="button" disabled={busy} onClick={open} className="min-h-11 text-gold underline" aria-label={`Edit pricing for ${service.name}`}>{busy?'Loading...':'Edit price, duration & deposit'}</button> : <div className="space-y-3 border-t border-white/20 pt-3">
            <div className="grid grid-cols-2 gap-3">{field('price','Price (£)')}{field('minutes','Minutes')}</div>
            <div className="grid grid-cols-2 gap-3">{field('deposit','Deposit amount')}<label className="block text-sm">Deposit type<select value={draft.depositPayment} onChange={e=>setDraft({...draft,depositPayment:e.target.value})}><option value="disabled">No deposit</option><option value="fixed">Fixed (£)</option><option value="percentage">Percentage (%)</option></select></label></div>
            <p className="text-xs text-white/60">Saves this variant’s pricing immediately.</p>
            <div className="flex gap-3"><button type="button" disabled={busy} onClick={save} className="min-h-11 px-4 rounded-full bg-gold text-navy">{busy?'Saving...':'Save variant pricing'}</button><button type="button" disabled={busy} onClick={()=>setDraft(null)}>Cancel</button></div>
        </div>}
        {error && <p role="alert" className="text-red-200 text-sm">{error}</p>}
    </div>;
}
